var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompactView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4.96501C1 1.99101 1.01874 1 3.33333 1C5.64793 1 5.66667 1.99101 5.66667 4.96501C5.66667 7.93901 5.67405 8.93002 3.33333 8.93002C0.992618 8.93002 1 7.93901 1 4.96501Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66699 4.96501C7.66699 1.99101 7.68573 1 10.0003 1C12.3149 1 12.3337 1.99101 12.3337 4.96501C12.3337 7.93901 12.341 8.93002 10.0003 8.93002C7.65961 8.93002 7.66699 7.93901 7.66699 4.96501Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.333 4.96501C14.333 1.99101 14.3517 1 16.6663 1C18.9809 1 18.9997 1.99101 18.9997 4.96501C18.9997 7.93901 19.0071 8.93002 16.6663 8.93002C14.3256 8.93002 14.333 7.93901 14.333 4.96501Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15.0348C1 12.0608 1.01874 11.0698 3.33333 11.0698C5.64793 11.0698 5.66667 12.0608 5.66667 15.0348C5.66667 18.0088 5.67405 18.9998 3.33333 18.9998C0.992618 18.9998 1 18.0088 1 15.0348Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66699 15.0348C7.66699 12.0608 7.68573 11.0698 10.0003 11.0698C12.3149 11.0698 12.3337 12.0608 12.3337 15.0348C12.3337 18.0088 12.341 18.9998 10.0003 18.9998C7.65961 18.9998 7.66699 18.0088 7.66699 15.0348Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.333 15.0348C14.333 12.0608 14.3517 11.0698 16.6663 11.0698C18.9809 11.0698 18.9997 12.0608 18.9997 15.0348C18.9997 18.0088 19.0071 18.9998 16.6663 18.9998C14.3256 18.9998 14.333 18.0088 14.333 15.0348Z",
    stroke: "#747474",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompactView);
export default __webpack_public_path__ + "static/media/compact-view.de928de8.svg";
export { ForwardRef as ReactComponent };